import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LoadingSpinnerComponent } from './loading-spinner.component';

@Injectable()
export class LoadingSpinnerService {

  public bsModalRef: BsModalRef;

  constructor(private modalService: BsModalService) { 

  }

  show(message: string = '') {
    this.bsModalRef = this.modalService.show(LoadingSpinnerComponent, { backdrop: 'static', class: 'gray modal-sm' });
    this.bsModalRef.content.message = message;
  }

  hide() {
    if (this.bsModalRef) {
      this.bsModalRef.hide();
    }
  }

}
